/**
 * ContentService - Handles admin content operations (e.g. international content activation)
 */

import type { HttpClient } from '../api/HttpClient';
import { API_ENDPOINTS } from '../api/ApiConfig';
import type { InternationalContentActionResponse } from '../../types/api/settings';

export class ContentService {
  private httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient;
  }

  /**
   * Activate international content
   * PUT /admin/content/international/activate
   */
  async activateInternationalContent(): Promise<InternationalContentActionResponse> {
    const response = await this.httpClient.put<InternationalContentActionResponse>(
      API_ENDPOINTS.ADMIN_CONTENT.INTERNATIONAL_ACTIVATE
    );

    if (!response.success) {
      throw new Error(response.message || 'Failed to activate international content');
    }

    return response.data;
  }

  /**
   * Deactivate international content
   * PUT /admin/content/international/deactivate
   */
  async deactivateInternationalContent(): Promise<InternationalContentActionResponse> {
    const response = await this.httpClient.put<InternationalContentActionResponse>(
      API_ENDPOINTS.ADMIN_CONTENT.INTERNATIONAL_DEACTIVATE
    );

    if (!response.success) {
      throw new Error(response.message || 'Failed to deactivate international content');
    }

    return response.data;
  }
}
